import React from "react";
import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";

const Navbar = () => {
  return (
    <>
      <Nav>
        <NavLink to="/">
          <h1>Ignite</h1>
        </NavLink>
        <NavMenu>
          <NavLink to="/games">Games</NavLink>
          <NavLink to="/services">Services</NavLink>
        </NavMenu>
      </Nav>
    </>
  );
};

// ? Styles

const Nav = styled.nav`
  background: rgba(42, 42, 42, 1);
  height: 80px;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem calc((100vw - 1200px) / 2);
  z-index: 10;
  /* Third Nav */
  /* justify-content: flex-start; */
  @media screen and (max-width: 768px) {
    padding: 0;
    justify-content: center;
  }

  @media screen and (max-width: 1000px) {
    padding: 0 5rem;
  }
`;

const NavLink = styled(Link)`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  &.active {
    color: #15cdfc;
  }
  h1 {
    color: white;
    font-family: "Abril Fatface", cursive;
    font-size: 2rem;
  }
`;

const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0px;
`;

export default Navbar;
